import { render, staticRenderFns } from "./shippingAddressDialog.vue?vue&type=template&id=03479bdb&scoped=true"
import script from "./shippingAddressDialog.vue?vue&type=script&lang=js"
export * from "./shippingAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03479bdb",
  null
  
)

export default component.exports